module.exports = __webpack_public_path__ + "img/emoji_64.c81f6178.png";